import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../styles/theme';

import type { GetAdministrativeInformationType } from '../../../types/GetAdministrativeInformation';

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.regular};
`;

const HeaderRow = styled.tr`
    background-color: Black;
    color: White;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.bold};

    @media print {
        background-color: Black !important;
        color: White !important;
    }
`;

const TableCell = styled.td`
    border: 1px solid black;
    white-space: nowrap;
`;

const Label = styled.div`
    font-size: ${props => props.theme.font.size.small};
    font-weight: ${props => props.theme.font.weight.bold};
`;

interface AdminInfoProps {
    administrativeInformation: GetAdministrativeInformationType;
}

const AdminInfo: React.FC<AdminInfoProps> = ({ administrativeInformation = null }) => {

    const formatTime = (time: string | undefined) => {
        if (!time) {
            return '\u00A0';
        }
        if (time.length >= 4) {
            return time.substring(0, 2) + ':' + time.substring(2, 4);
        }
        return time;
    }

    const convertTimeToString = (time: number | undefined) => {
        return time !== undefined ? time.toString().padStart(6, '0') : undefined;
    }

    const formatLocation = (address: string = '\u00A0', city: string = '\u00A0', state: string = '\u00A0', zip: string = '\u00A0') => {
        return `${address}, ${city}, ${state} ${zip}`;
    };



    return (
        <ThemeProvider theme={theme} >
            <Table cellPadding="0" cellSpacing="0">
                <tbody>
                    <HeaderRow>
                        <td>Administrative Information</td>
                    </HeaderRow>
                    <tr>
                        <td>
                            <Table cellPadding="2" cellSpacing="0">
                                <tbody>
                                    <tr>
                                        <TableCell>
                                            <Label>Agency</Label>
                                            {administrativeInformation?.agency || '\u00A0'}
                                        </TableCell>
                                        <TableCell>
                                            <Label>Report No</Label>
                                            {administrativeInformation?.reportNo || '\u00A0'}
                                        </TableCell>
                                        <TableCell>
                                            <Label>Reported Date</Label>
                                            {administrativeInformation?.reportDate || '\u00A0'}
                                        </TableCell>
                                        <TableCell>
                                            <Label>Reported Time</Label>
                                            {administrativeInformation?.reportTime ? formatTime(convertTimeToString(administrativeInformation.reportTime)) : '\u00A0'}
                                        </TableCell>
                                        <TableCell width="100%">
                                            &nbsp;
                                        </TableCell>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Table cellPadding="2" cellSpacing="0">
                                <tbody>
                                    <tr>
                                        <TableCell>
                                            <Label>Classification</Label>
                                            {administrativeInformation?.classification || '\u00A0'}
                                        </TableCell>
                                        <TableCell>
                                            <Label>Location</Label>
                                            {administrativeInformation ? formatLocation(administrativeInformation.location, administrativeInformation.city, administrativeInformation.state, administrativeInformation.zipCode) : '\u00A0'}
                                        </TableCell>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Table cellPadding="2" cellSpacing="0">
                                <tbody>
                                    <tr>
                                        <TableCell>
                                            <Label>From Date</Label>
                                            {administrativeInformation?.fromDate || '\u00A0'}
                                        </TableCell>
                                        <TableCell>
                                            <Label>From Time</Label>
                                            {administrativeInformation?.fromTime ? formatTime(convertTimeToString(administrativeInformation.fromTime)) : '\u00A0'}
                                        </TableCell>
                                        <TableCell>
                                            <Label>To Date</Label>
                                            {administrativeInformation?.toDate || '\u00A0'}
                                        </TableCell>
                                        <TableCell>
                                            <Label>To Time</Label>
                                            {administrativeInformation?.toTime ? formatTime(convertTimeToString(administrativeInformation.toTime)) : '\u00A0'}
                                        </TableCell>
                                        <TableCell width="100%">
                                            &nbsp;
                                        </TableCell>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Table cellPadding="2" cellSpacing="0">
                                <tbody>
                                    <tr>
                                        <TableCell>
                                            <Label>Officer</Label>
                                            {administrativeInformation?.officer || '\u00A0'}
                                        </TableCell>
                                        <TableCell>
                                            <Label>Officer Number</Label>
                                            {administrativeInformation?.officerNumber || '\u00A0'}
                                        </TableCell>
                                        <TableCell width="100%">
                                            &nbsp;
                                        </TableCell>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </ThemeProvider>
    );
}

export default AdminInfo;
